var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c(_vm.layout,{tag:"component"},[_c('transition',{attrs:{"name":"fade"}},[(_vm.initialized)?_c('router-view'):_vm._e()],1)],1),_c('snack-bar'),(_vm.loading.state)?_c('loader'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }